<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="row">
      <div class="col col-md-6 col-lg-7 hidden-sm-down">
        <img src="/img/logo-scm.svg" class="w-100" aria-roledescription="logo" :alt="appTitle" />
        <h2 class="fs-xxxl fw-900 mt-4 ls-2 d-none">Smart Club Manager</h2>
        <h4 class="h3 fw-400 mt-3 mb-5 text-right">{{$t('titles.manageSports')}}</h4>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4 ml-auto">
        <div class="card p-4 rounded-0 bg-faded">
          <h1 class="h2 text-left fw-600 mb-4 d-xs-block">{{ $t('titles.log-in') }}</h1>

          <form>
            <div class="form-group">
              <w-input :model="$schema.login" :title="$t($schema.login.$schema.title)" />
            </div>

            <div class="form-group">
              <w-input
                type="password"
                :model="$schema.password"
                :title="$t($schema.password.$schema.title)"
              />
            </div>

            <div class="row no-gutters">
              <div class="col-lg-12 pl-lg-1 my-2 text-center">
                <button
                  class="btn btn-info btn-block btn-lg btn-smart rounded-pill"
                  @click.prevent="submit()"
                >{{ $t('buttons.log-in') }}</button>
              </div>
            </div>

            <div class="mx-1 my-1 text-center label">
              <router-link :to="{ name: 'reset' }">{{ $t('text.forgot-password') }}</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/login.schema';
import { Storage } from '@/enums/storage.enum';

// @vuese
// Logowanie
// @group Start
export default {
  mixins: [formMixin, notificationsMixin],
  external: {},
  data() {
    return {
      list: [],
      model: {}
    };
  },
  schema,
  methods: {
    // @vuese
    // Loguje użytkownika
    submit() {
      if (!this.$schema.$validateAll().length) {
        localStorage.removeItem(Storage.TOKEN);
        this.$store
          .dispatch('auth/login', this.model)
          .then(res => this.$router.push({ name: 'home', params: { view: 'week' } }))
          .catch(error => this.notifyError('messages.auth.loginError'));
      }
    }
  },
  computed: mapState({
    appTitle: state => state.system.appTitle
  })
};
</script>

<style scoped>
h4.h3 {
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>
